/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import PopUp from '../../../common/PopUp/PopUp'
import Mta from './MtaPopUp'
import { getSettlementBasis, settlementBasisCalc } from '../../../common/SettlementBasis'

import AddressBlock from '../../Quote/Step02/components/AddressBlock'

/**
 *     Import
 *     - Styles
 */
import '../styles/BindQuote.css'

export default class ViewPolicy extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            renewPolicyPopUp: {
                show: false,
            },
            addMtaPopUp: false,
        }
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof BindQuote
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    componentDidMount() {
        this.props.getPolicySingle(this.props.match.params.policyId)
    }

    handleEdit = () => {
        return true
    }

    columnChunks = (arr, size) => {
        if (!Array.isArray(arr)) {
            throw new TypeError('Input should be Array')
        }

        if (typeof size !== 'number') {
            throw new TypeError('Size should be a Number')
        }

        let result: any = []
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, size + i))
        }

        return result
    }

    handleRenew = () => {
        this.setState({
            renewPolicyPopUp: {
                show: true,
                renewId: this.props.match.params.policyId,
            },
        })
    }

    handleDownload = () => {
        return true
    }

    handleRequestExtension = () => {
        this.props.extendSubjectivity(this.props.match.params.policyId)
    }

    handleMarkSubCompleted = () => {
        return true
    }

    handleMta = () => {
        this.setState({ addMtaPopUp: !this.state.addMtaPopUp })
    }

    render() {

        let policy = this.props.policy.response

        const operativeSections = this.columnChunks(policy.operativeSections, 5)

        return (
            <div className="policy">
                {(this.state.renewPolicyPopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Renew Policy'}
                            action={() => { alert('OK, just wait... :P') }}
                            buttonText={'Renew as is'}
                            numberButtons={3}
                            secondaryAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.renewPolicyPopUp.renewId}`)

                            }}
                            secondaryButtonText={'Edit details'}
                            thirdAction={() => { this.setState({ renewPolicyPopUp: { show: false } }) }}
                            thirdButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            <div className="download_pdf_policy">
                                Download pdf policy form
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.state.addMtaPopUp) ?
                    <div className="addMta">
                        <PopUp
                            title="Add Mid Term Adjustment"
                            action={() => { this.handleMta() }}
                            buttonText="Continue"
                            secondaryAction={() => { this.handleMta() }}
                            secondaryButtonText="Cancel"
                        >
                            <Mta />
                        </PopUp>
                    </div>
                    : null}
                <HeaderContainer
                    className="policy__header"
                    fullwidth={true}
                    titles={['Quote Bound']}
                    back={true}
                    backAction={() => this.props.history.goBack()}
                >
                {/* <div className="policy__gratitude">Thank you, a brief summary of your policy is below. The Schedule
                    and risk presentation documents have been emailed to you, along with a copy of the policy wording.
                    The documentation will also be available in your dashboard.
                    </div> */}
                </HeaderContainer>

                <Container className="summary" fullwidth={false}>
                    <div className="summary__message unsetPadding">
                        <h4>Thank you</h4>
                        <h5>
                            A brief summary of your policy is below.
                            The Schedule and risk presentation documents have been emailed to you,
                            along with a copy of the policy wording.
                            The documentation will also be available in your dashboard.
                        </h5>
                    </div>
                    <div className="summary__box">
                        <div className="summary__header">
                            <div className="summary__header__title">
                                {policy.clientName}
                            </div>
                            <div className="summary__header__subtitle">
                                {policy.policyName}
                            </div>
                            <div className="summary__header__policyInfo">
                                Policy reference. <span>{policy.policyNumber}</span>
                            </div>
                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Inception date</div>
                                <div className="summary__infoBlock__value"><span>{policy.inceptionDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Expiry date</div>
                                <div className="summary__infoBlock__value"><span>{policy.expiryDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Premium</div>
                                <div className="summary__infoBlock__value"><span>£{policy.premium}</span> inc.IPT</div>
                            </div>

                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Your commission</div>
                                <div className="summary__infoBlock__value"><span>{policy.commission}%</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Excess</div>
                                <div className="summary__infoBlock__value">
                                    <span>
                                        {(typeof (policy.excess) === 'number') ?
                                            (policy.excess).toLocaleString('en-GB', {
                                                style: 'currency',
                                                currency: 'GBP',
                                            })
                                            : `£${policy.excess}`
                                        }
                                    </span>
                                </div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">
                                    {(policy.policyName === 'Collectors' || policy.isCollectors) ?
                                        'Collection value insured' : policy.isMuseums ? 'Total Exhibits Sum Insured' :
                                            `Total ${policy.isDealersStock ? 'dealers stock' :
                                                policy.isWineSpirits ? 'collection' : 'stock'} sum insured`}
                                </div>
                                <div className="summary__infoBlock__value">
                                    <span>£{policy.totalSumInsured}</span>
                                </div>
                            </div>
                            {((policy.policyName === 'Collectors' || policy.isCollectors)
                                || policy.isMuseums || policy.isWineSpirits) ? null :
                                <div className="summary__infoBlock">
                                    <div className="summary__infoBlock__title">Settlement basis</div>
                                    <div className="summary__infoBlock__value">
                                        <span>
                                            {getSettlementBasis(policy.priceBasis, policy.settlementBasis)}
                                            {settlementBasisCalc(policy.settlementBasis)}%
                                        </span>
                                    </div>
                                </div>}
                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock__value">
                                <span>
                                    {(policy.policyName === 'Collectors' || policy.isCollectors ||
                                        policy.isMuseums || policy.isWineSpirits) &&
                                        policy.riskLocations && (policy.riskLocations).length > 0 ?
                                        'Risk addresses' : 'Operative sections'}
                                </span>
                            </div>
                            {/* {operativeSections.map((row, i) => (
                                        <div key={i} className="summary__infoBlock">
                                            {
                                                row.map((col, y) => (
                                                    <div key={y} className="summary__infoBlock__value">{col}</div>
                                                ))
                                            }
                                        </div>
                                    ))
                                    } */}
                            {(policy.policyName === 'Collectors' || policy.isCollectors ||
                                policy.isMuseums || policy.isWineSpirits) &&
                                policy.riskLocations && (policy.riskLocations).length > 0 ?
                                <div className="PolicyAddressShow">
                                    {policy.riskLocations.map((r, i) => {
                                        return (
                                            <AddressBlock
                                                key={i}
                                                // id={r.id}
                                                // quoteId={parseInt(this.props.match.params.id, 10)}
                                                addressType={r.addressType}
                                                addressLine1={r.addressLine1}
                                                addressLine2={r.addressLine2}
                                                city={r.city}
                                                postcode={r.postcode}
                                                addressAllocated={r.allocated}
                                            />
                                        )
                                    })}
                                </div>
                                :
                                operativeSections.map((row, i) => (
                                    <div key={i} className="summary__infoBlock">
                                        {
                                            row.map((col, y) => (
                                                <div key={y} className="summary__infoBlock__value">{col}</div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className="summary__actions">
                        <Button
                            className="summary__action__renew"
                            onClick={() => { this.handleRenew() }}
                        >
                            Renew policy
                        </Button>

                        <Button
                            className="summary__action__download"
                            onClick={this.handleDownload}
                        >
                            download schedule
                        </Button>

                        <Button
                            className="summary__action__mta"
                            onClick={this.handleMta}
                        >
                            Add mid term ajustment
                        </Button>

                    </div>

                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/BindQuote.tsx